import "./loader.css";
const Spinner = () => {
  return <span className="loader"></span>;
};
export default Spinner;
